import type { DefaultTheme } from 'styled-components';
import chroma from 'chroma-js';
import { selectHighestContrast } from '../elc/features/learner/utils';

export const getLettersForAvatar = (name?: string): string => {
  if (!name?.trim()) {
    return '';
  }

  const [firstName, ...lastNames] = name.split(' ');

  const firstInitial = firstName?.[0];
  const lastInitial = lastNames[lastNames.length - 1]?.[0];

  return [firstInitial, lastInitial].join('');
};

export const getColorsForAvatar = (theme: DefaultTheme, brandColor?: string) => {
  if (!brandColor) {
    return {
      backgroundColor: theme.colors.primary[100],
      foregroundColor: theme.colors.primary[500],
    };
  }

  const contrastColor = selectHighestContrast(brandColor, [
    theme.colors.on[0],
    chroma(theme.colors.on[800]).alpha(0.8).hex(),
  ]);

  return { backgroundColor: brandColor, foregroundColor: chroma(contrastColor).hex('rgba') };
};
